import * as Yup from 'yup';
import { GarageType } from '../../../../domain/types/garageType';

const upsertPropertyGarageValidationSchema = (type: GarageType | '') => Yup.object({
  type: Yup.string().oneOf(Object.values(GarageType)).required('Il campo è obbligatorio'),
  size: Yup.number()
    .integer('Inserisci un numero intero')
    .positive('Inserisci un numero positivo'),
  adjacent: Yup.boolean(),
  floor: type === GarageType.BOX
    ? Yup.number().lessThan(1, 'Il piano del box deve essere minore o uguale a 0')
    : Yup.number(),
});

export default upsertPropertyGarageValidationSchema;
